import BaseChoiceProField from "../SingleChoiceProField/BaseChoiceProField";

export default{
    mixins:[BaseChoiceProField],
    computed: {
        valueString: function () {
            return JSON.stringify(this.data[this.name]);
        }
    },
    methods:{
        handlerValueWhenChangeOptions:function(){
            if(!this.isAddable){
                if((this.data[this.name] || []).length == 0)
                {
                    return;
                }
                let newValues = new Array();
                
                (this.data[this.name] || []).forEach(x=>{
                    let optionIndex = this.options.findIndex(option=> option.Value === x);
                    if(optionIndex > -1){
                        newValues.push(this.options[optionIndex].Value);
                    }
                });
                if(newValues.length == (this.data[this.name] || []).length){
                    return;
                }
                else{
                    this.data[this.name] = newValues;
                }
            }
            else{
                let value = this.data[this.name] || [];
                let hasValues = this.options.filter(option=> value.includes(option.Value)).map(x=>x.Value);
                let noHasValues = value.filter(x=> !hasValues.includes(x));
                noHasValues.forEach(x=>{
                    this.options.push({
                        "Value":x,
                        "Label":x,
                        "label":x,
                        "value":x
                    })
                })
            }
        },
    }
}